import { refreshTable } from '@packages/table-builder';
import { queryClient } from '@/queryClient';
import { ACCESS_PROFILE_CONFIG, type AccessProfileScope } from '@/pages/settings/access-profiles/types';

export const ACCESS_PROFILE_ROLE_ENTITY = 'access-profile-role';
export const ACCESS_PROFILE_FEATURE_SET_ENTITY = 'access-profile-feature-set';

export function accessProfileEntity(scope: AccessProfileScope): string {
  return scope === 'Role' ? ACCESS_PROFILE_ROLE_ENTITY : ACCESS_PROFILE_FEATURE_SET_ENTITY;
}

export function refreshAccessProfileTable(
  scope: AccessProfileScope,
  registryRefresh?: () => void,
): void {
  registryRefresh?.();
  refreshTable(accessProfileEntity(scope));
  void queryClient.invalidateQueries(ACCESS_PROFILE_CONFIG[scope].queryKey);
  void queryClient.invalidateQueries('dt-v2-page');
}
